import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { isBrowser } from 'Helpers/Browser';
import { getSearchObject } from 'Helpers/Uri';

import Spinner from 'Components/layout/Spinner';
import Select from 'Components/forms/Select';
import Button from 'Components/layout/Button';

export default class GalleryFilters extends React.Component {
    static propTypes = {
        location: PropTypes.object,
        filters: PropTypes.objectOf(
            PropTypes.shape({
                options: PropTypes.arrayOf(
                    PropTypes.shape({
                        value: PropTypes.string.isRequired,
                        label: PropTypes.string.isRequired
                    })
                )
            })
        ),
        onFiltersChange: PropTypes.func.isRequired
    };
    static defaultProps = {
        filters: {}
    }

    constructor(props) {
        super(props);

        this.state = {
            visible: false
        };

        if (props.filters) {
            Object.keys(props.filters).map(filter => {
                this.state[filter] = '';
            });
        }

        const currentFilters = this.getUrlFilters(props);
        this.state = {
            ...this.state,
            ...currentFilters,
            visible: Object.keys(currentFilters).length ? true : false
        };
    }

    getUrlFilters = props => {
        const searchParams = getSearchObject(props.location.search);
        let output = {};

        Object.keys(searchParams).map(searchParam => {
            if (typeof props.filters[searchParam] !== 'undefined' && props.filters[searchParam].options && props.filters[searchParam].options.length) {
                const options = props.filters[searchParam].options;
                let avaiableOptions = options.map(option => {
                    return option.value;
                });

                output[searchParam] = avaiableOptions.indexOf(searchParams[searchParam]) > 0 ? searchParams[searchParam] : '';
            } else {
                output[searchParam] = '';
            }
        });

        return output;
    }

    onFiltersChange = (name, value) => {
        const currentFilters = this.getUrlFilters(this.props, window.location);
        const newState = {
            ...currentFilters,
            [name]: value || ''
        };

        this.setState(newState);
        this.props.onFiltersChange(newState);
    }

    render() {
        if (!this.props.filters || !Object.keys(this.props.filters).length) {
            return (null);
        }

        return (
            <div className="component-gallery-filters clearfix">
                <a className="mobile-trigger" onClick={() => this.setState({ ...this.state, visible: !this.state.visible })}>{this.state.visible ? 'Hide filters' : 'Show filters'}</a>
                <div className={`filters-content ${this.state.visible ? 'mobile-visible' : ''}`}>
                    <p className="label">Filter by: </p>
                    {
                        Object.keys(this.props.filters).map(filter => {
                            if (this.props.filters[filter].hasOwnProperty('ignore')) {
                                return (null);
                            }

                            return (
                                <div className={`filter-container ${filter}`} key={filter}>
                                    <Select
                                        name={filter}
                                        required={false}
                                        className="secondary"
                                        value={this.state[filter]}
                                        options={this.props.filters[filter].options}
                                        onChange={this.onFiltersChange}
                                    >
                                    </Select>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/GalleryFilters/index.js